import React from 'react';
import { useTranslation } from 'react-i18next';

import { getPremiumStyled, RETURN_VALUE_ONLY } from '../../../../utils';
import { CategoryCoverageDto } from '../../../../queries/useBenefitCategoryQuery/types';


interface HsaPlanDetailsProps{
  coverage: CategoryCoverageDto | null | undefined;
}

export const HsaPlanDetails = ( {coverage}: HsaPlanDetailsProps) => {
  const { t } = useTranslation('pages.enrollment.review');
  const totalAnnualEmployeeContribution = coverage?.req_subscriber_fsa_amount ? coverage?.req_subscriber_fsa_amount : "0";
  const totalScheduledLumpSumAmount = coverage?.total_ee_scheduled_lump_sum_amount ? coverage?.total_ee_scheduled_lump_sum_amount : "0";

  return (
      <div className="d-flex mb-2_5 flex-column">
        <div>
          {t('totalAnnualEmployeeContribution')}
          <span className="semiBold pl-2">
                    {getPremiumStyled({
                      premium: totalAnnualEmployeeContribution,
                      valueOnly: RETURN_VALUE_ONLY,
                    })}
          </span>
        </div>
        <div>
          {t('totalScheduledLumpSumAmount')}
          <span className="semiBold pl-2">
                  {getPremiumStyled({ premium: totalScheduledLumpSumAmount, valueOnly: RETURN_VALUE_ONLY })}
          </span>
        </div>
      </div>
  );
};
